import React, { useEffect, useState } from "react"
import { View, StyleSheet, ScrollView, Dimensions, BackHandler } from "react-native"
import { IconButton } from "react-native-paper"
import { Button } from "@Components/CustomButton/Button"
import { ContainerGlogal } from "@Components/ContainerGlogal"
import { InputGroup } from "@Components/Input/InputGroups"
import { BreeSerifText } from "@Components/CustomText/BreeSerifText"
import { OpenSansText } from "@Components/CustomText/OpenSansText"
import { baseColors } from "@Constants/baseStyles"
import { TransformToLowerCase, isValidEmail } from "@Utils/utils"
import { ShowToast } from "@Components/ToastNotification/ToastNotification"
import { message } from "@Constants/constant"
import { useRecoilState } from "recoil"
import { passwordResetEmailAtom } from "@Recoil/Atom/passwordCodeAtom"
import { AXIOS_HEADERS, FORGOT_PASSWORD_BASE_URL } from "@Services/AxiosInstance"
import axios from "axios"
import { MaterialCommunityIcons } from "@expo/vector-icons"

const { height } = Dimensions.get("screen")
export const ForgotPasswordPage = ({ navigation }) => {
    const [email, setEmail] = useRecoilState(passwordResetEmailAtom)
    const [loading, setLoading] = useState(false)
    const goBack = () => navigation.goBack()

    const sendMail = () => {
        const payload = { email, fromMobile: 1 }
        setLoading(true)
        axios
            .put(FORGOT_PASSWORD_BASE_URL(), { ...payload }, AXIOS_HEADERS)
            .then((response) => {
                console.log({ code: response?.data?.code })
                if (response?.data?.code === 403) {
                    ShowToast({ type: "error", message: "Veuillez utiliser un compte patient" })
                } else if (response?.data?.code === 404) {
                    ShowToast({ type: "error", message: "Compte introuvable" })
                } else {
                    navigation.navigate("PasswordForgotCode")
                }
                setLoading(false)
            })
            .catch((err) => {
                console.log({ err })
                setLoading(false)
                ShowToast({ type: "error", message: message.serverError })
            })
    }

    useEffect(() => {
        const backAction = () => {
            return true
        }
        const backHandler = BackHandler.addEventListener("hardwareBackPress", backAction)
        return () => backHandler.remove()
    }, [])

    return (
        <ContainerGlogal>
            <ScrollView keyboardShouldPersistTaps={"handled"} contentContainerStyle={{ paddingBottom: 50 }}>
                <View style={{ paddingHorizontal: 10 }}>
                    <IconButton
                        rippleColor={"rgba(0,0,0,0.9)"}
                        iconColor="white"
                        onPress={() => goBack()}
                        icon="arrow-left"
                        size={24}
                        style={{
                            backgroundColor: baseColors.green.primary,
                            borderRadius: 8,
                            width: 35,
                            height: 35
                        }}
                    />
                </View>

                <View style={[styles.container, { marginTop: height / 7 }]}>
                    <BreeSerifText fontSize={22} style={{ marginBottom: 10 }}>
                        Mot de passe oublié ?
                    </BreeSerifText>
                    <OpenSansText fontSize={16}>
                        Pour réinitialiser votre mot de passe, veuillez indiquer votre adresse mail. Nous vous enverrons
                        un mail avec des instructions pour modifier votre mot de passe.
                    </OpenSansText>
                    <View style={{ marginTop: 20 }}>
                        <InputGroup
                            validation_message={"obligatoire"}
                            onChange={(text) => setEmail((old) => text)}
                            disabled={loading}
                            valid={email.length > 0}
                            value={email}
                            label={"Adresse mail"}
                            placeholder={"Entrez votre adresse mail"}
                        />
                    </View>
                    {email.length > 0 && !isValidEmail(email) && (
                        <BreeSerifText
                            textAlign={"center"}
                            color={baseColors.orange.primary}
                            fontSize={16}
                            fontWeight={"normal"}
                        >
                            Adresse mail invalide.
                        </BreeSerifText>
                    )}
                    <Button
                        loading={loading}
                        disabled={!isValidEmail(email) || loading}
                        onPress={sendMail}
                        text="réinitialiser"
                        width="80%"
                        backgroundColor={baseColors.green.primary}
                        labelColor={"white"}
                    />
                </View>
            </ScrollView>
        </ContainerGlogal>
    )
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
        paddingTop: 20,
        paddingHorizontal: 20,
        backgroundColor: "white",
        alignContent: "center"
    },
    text: {
        color: baseColors.black,
        textAlign: "justify",
        fontFamily: "BreeSerif",
        fontSize: 16
    }
})
